import React, { useEffect, useRef } from 'react';
import { Box, BoxProps } from '../ui/layout/Box';

type WothLoadMoreProps = {
    onLoadMore: VoidFunction;
    threshold?: number;
    children: React.ReactNode;
} & BoxProps;

export const WithLoadMore: React.FC<WothLoadMoreProps> = ({
    onLoadMore,
    threshold = 0.5,
    children,
    ...boxParams
}) => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    onLoadMore();
                    observer.disconnect();
                }
            },
            { threshold },
        );

        observer.observe(ref.current!);

        return () => observer.disconnect();
    }, []);

    return (
        <Box ref={ref} {...boxParams}>
            {children}
        </Box>
    );
};
